import React from "react";
import { useDropzone } from "react-dropzone";
import assetsManager from "../assets/assetsmanager/assestsmanager";

function FolderDropzone({
  setFiles,
  multiSelect,
  files,
  selectedPdfName,
  setIsFileNameNotSame
}) {
  // handle drop files
  const onDrop = (acceptedFiles) => {
    //filters files of PDF formats
    const pdfFiles = acceptedFiles.filter(
      (file) => file.type === "application/pdf"
    );

    //end flow if zero pdfs selected
    if (pdfFiles.length === 0) return;

    // edit pdf modal flow
    if (!multiSelect) {
      //check if new pdf name matches with selected pdf // as the name should be same while editing pdf
      let newFile = pdfFiles.find((item, i) => {
        return item.name === selectedPdfName;
      });
      if (!newFile) {
        // if name not matches
        setIsFileNameNotSame(true);
      } else {
        // if name matches
        setIsFileNameNotSame(false);
      }
      //set selected file
      setFiles(newFile ? [newFile] : []);
      return;
    }
    // upload pdf modal flow

    //fetching already selected pdf names
    const existingFileNames = files.map((file) => file.name);

    //filtering pdf for not selected files or files with unique names so files should not overrides or replaces
    const newPdfFiles = pdfFiles.filter(
      (file) => !existingFileNames.includes(file.name)
    );
    // if no files left after filtering
    if (newPdfFiles.length === 0) return;

    // setting filtered files
    setFiles((prev) => [...prev, ...newPdfFiles]);
  };

  //destructuring hooks
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div
      {...getRootProps()}
      className={`dropzone bg-[#B73838] rounded-md border-[#B73838] border-dashed border-[1px] flex items-center justify-center flex-col p-6 ${
        isDragActive ? "bg-opacity-20" : "bg-opacity-10"
      }`}
    >
      <input {...getInputProps()} />
      <img src={assetsManager.uploadIconForModal} alt="" />
      <p className="text-md text-[#333333] font-medium">
        Drag & drop files or{" "}
        <span className="text-[#A83E3E] cursor-pointer">Browse</span>
      </p>
      <p className="text-xs text-[#676767]">Supported formates: PDFs,URLs</p>{" "}
    </div>
  );
}

export default FolderDropzone;
